module.exports = __webpack_public_path__ + "static/media/shield-1086703_1280.44bcf864.png";